import { render } from "./ChangeLang.vue?vue&type=template&id=6040fc2c&scoped=true"
import script from "./ChangeLang.vue?vue&type=script&lang=js"
export * from "./ChangeLang.vue?vue&type=script&lang=js"

import "./ChangeLang.vue?vue&type=style&index=0&id=6040fc2c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6040fc2c"]])

export default __exports__